import { CircularProgress } from '@mui/material';
import { useDataProvider, useLocalization } from '@ui-framework/index';
import { useEffect, useState } from 'react';
import InfoBlock from './InfoBlock';

function DistanceFromCustomer({ jobLocation, serviceProviderAddressLocation }) {
  const { get, getApiUrl } = useDataProvider();
  const { formatMessage } = useLocalization();
  const [distance, setDistance] = useState(0);
  const [loading, isLoading] = useState(true);

  const query = `destinationLat=${serviceProviderAddressLocation.lat}&destinationLng=${serviceProviderAddressLocation.lng}&originLat=${jobLocation.lat}&originLng=${jobLocation.lng}`;

  const apiUrl = `${getApiUrl()}/sxcl/v1/geocoding/routing-distance?${query}`;

  const getDistance = async () => {
    isLoading(true);
    const response = await get(apiUrl);
    if (response?.ok) {
      setDistance(response?.data?.distance || '');
    }
    isLoading(false);
  };

  useEffect(() => {
    getDistance();
  }, []);

  if (loading) {
    return <CircularProgress sx={{ ml: 1 }} size={15} />;
  }

  return (
    <InfoBlock
      label={formatMessage({
        id: 'DISTANCE_FROM_CUSTOMER',
        defaultMessage: 'Distance from customer: ',
      })}
      value={distance}
    />
  );
}

export default DistanceFromCustomer;
